/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthRequired from '@/utils/AuthRequired'

Vue.use(VueRouter)

const routes = [{
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '',
    component: () => import('./layouts/main/Main.vue'),
    beforeEnter: AuthRequired,
    children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
      {
        path: '/',
        name: 'home',
        component: () => import('./views/Home.vue')
      },
      {
        path: '/mini/list',
        name: 'mini-list',
        component: () => import('./views/mini/List.vue')
      },
      {
        path: '/goods/list',
        name: 'goods-list',
        component: () => import('./views/goods/List.vue')
      },
      {
        path: '/goods/add',
        name: 'goods-add',
        component: () => import('./views/goods/Add.vue')
      },
      {
        path: '/category/list',
        name: 'category-list',
        component: () => import('./views/category/List.vue')
      },
      {
        path: '/category/add',
        name: 'category-add',
        component: () => import('./views/category/Add.vue')
      },
      {
        path: '/order',
        name: 'order',
        component: () => import('./views/order/Index.vue')
      },
      {
        path: '/store/list',
        name: 'shopList',
        component: () => import('./views/store/Index.vue')
      },
      {
        path: '/store/add',
        name: 'shopCreate',
        component: () => import('./views/store/detail.vue')
      },
      {
        path: '/store/detail',
        name: 'shopDetail',
        component: () => import('./views/store/detail.vue')
      },
      {
        path: '/tax/list',
        name: 'taxList',
        component: () => import('./views/tax/Index.vue')
      },
      {
        path: '/auth/role',
        name: 'auth-role',
        component: () => import('./views/auth/Role.vue')
      },
      {
        path: '/auth/node',
        name: 'auth-node',
        component: () => import('./views/auth/Node.vue')
      },
      {
        path: '/member/list',
        name: 'member',
        component: () => import('./views/member/Index.vue')
      },
      {
        path: '/sales/coupon',
        name: 'sales-coupon',
        component: () => import('./views/sales/Coupon.vue')
      },
      {
        path: '/sales/recommend',
        name: 'sales-recommend',
        component: () => import('./views/sales/Recommend.vue')
      },
      {
        path: '/sales/group',
        name: 'sales-group',
        component: () => import('./views/sales/Group.vue')
      },
      {
        path: '/pay/setting',
        name: 'paySetting',
        component: () => import('./views/paySetting/PaySetting.vue')
      },
    ],
  },
  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('@/views/pages/Register.vue')
      },
      {
        path: '/pages/error-404',
        name: 'page-error-404',
        component: () => import('@/views/pages/Error404.vue')
      },
    ]
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/pages/error-404'
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
